import { type ColumnDef, createColumnHelper } from '@tanstack/react-table';
import type { PrestationTransactionFormatted } from '@/api/prestation-transactions/prestation-transactions.types';
import { Badge, BadgeColor } from '@/components/Badge';
import { formatDate } from '@/utils/date.utils';
import { DebtOrCreanceAmount } from '../components/DebtOrCreanceAmount';
import { PaymentScheduleBadge } from '../transactions/components/PaymentScheduleBadge';

const columnHelper = createColumnHelper<PrestationTransactionFormatted>();

const CANCELLED_LABEL = 'Annulé';

export const employeeTransactionsColumns = [
  columnHelper.accessor((row) => row.date, {
    id: 'date',
    header: 'Date',
    cell: (info) => formatDate(info.getValue()),
  }),
  columnHelper.accessor((row) => row.totalAmount.abs().toNumber(), {
    id: 'totalAmount',
    header: 'Montant',
    cell: (info) => <DebtOrCreanceAmount amount={info.row.original.totalAmount} />,
    meta: { filterType: 'numeric' },
  }),
  columnHelper.accessor('methodFormatted', {
    header: 'Mode de règlement',
    cell: (info) => (
      <div className="flex flex-wrap items-center gap-2">
        {info.getValue()}
        <PaymentScheduleBadge transaction={info.row.original} />
      </div>
    ),
    meta: { filterType: 'text' },
  }),
  columnHelper.accessor('reference', {
    header: 'Référence',
    meta: { filterType: 'text' },
  }),
  columnHelper.accessor((row) => (row.cancelledAt ? CANCELLED_LABEL : row.statusFormatted), {
    id: 'statusFormatted',
    header: 'Statut',
    cell: (info) =>
      info.row.original.cancelledAt ? (
        <Badge color={BadgeColor.RED}>{CANCELLED_LABEL}</Badge>
      ) : (
        info.getValue()
      ),
    meta: { filterType: 'text' },
  }),
] as ColumnDef<PrestationTransactionFormatted>[];
